export default __webpack_public_path__ + "static/media/ico-smazat-soubor.a0727d56.svg";